import { Dimensions } from 'react-native';
const screenWidth = 390;
const screenHeight = 844;

const containerWidth = screenWidth * 0.9;
const containerHeight = screenHeight * 0.9;

//card overlap on each other angles
export const cardPositionAngles = {
  2: [-5, 5],
  4: [-8, -3, 3, 8],
  5: [-10, -5, 0, 5, 10],
  6: [-25, -15, -5, 5, 15, 25],
};

//card positions from left space
export const cardsPositions = {
  //9 players cards (2,4,5,6)
  '9-2': [32, 0, 0, 0, 0, 32, 32, 32, 32],
  '9-4': [32, 12, 12, 12, 12, 12, 12, 12, 12],
  '9-5': [32, 10, 10, 10, 10, 10, 10, 10, 10],
  '9-6': [32, 7, 7, 7, 7, 7, 7, 7, 7],

  //2 players cards (2,4,5,6)
  '2-2': [32, 32],
  '2-4': [32, 32],
  '2-5': [32, 32],
  '2-6': [32, 32],

  //3 players cards (2,4,5,6)
  '3-2': [32, 0, 32],
  '3-4': [32, 0, 32],
  '3-5': [32, 0, 32],
  '3-6': [32, 0, 32],

  //4 players cards (2,4,5,6)
  '4-2': [32, 0, 32, 32],
  '4-4': [32, 0, 32, 32],
  '4-5': [32, 0, 32, 32],
  '4-6': [32, 0, 32, 32],

  //5 players cards (2,4,5,6)
  '5-2': [32, 0, 0, 32, 32],
  '5-4': [32, 0, 0, 32, 32],
  '5-5': [32, 0, 0, 32, 32],
  '5-6': [32, 0, 0, 32, 32],

  //6 players cards (2,4,5,6)
  '6-2': [32, 0, 0, 32, 32, 32],
  '6-4': [32, 0, 0, 32, 32, 32],
  '6-5': [32, 0, 0, 32, 32, 32],
  '6-6': [32, 0, 0, 32, 32, 32],

  //7 players cards (2,4,5,6)
  '7-2': [32, 0, 0, 0, 32, 32, 32],
  '7-4': [32, 0, 0, 0, 32, 32, 32],
  '7-5': [32, 0, 0, 0, 32, 32, 32],
  '7-6': [32, 0, 0, 0, 32, 32, 32],

  //8 players cards (2,4,5,6)
  '8-2': [32, 0, 0, 0, 32, 32, 32, 32],
  '8-4': [32, 0, 0, 0, 32, 32, 32, 32],
  '8-5': [32, 0, 0, 0, 32, 32, 32, 32],
  '8-6': [32, 0, 0, 0, 32, 32, 32, 32],
};

//card positions in hand vertical offset
export const verticalOffsets = {
  2: [14, 14],
  4: [14, 12, 12, 14],
  5: [15, 12, 10, 12, 15],
  6: [22, 16, 10, 10, 16, 22],
};

//original raw postions wit number of players
export const rawPositions = {
  9: [
    {
      id: 1,
      top: containerHeight * 0.85,
      left: containerWidth * 0.5,
      angle: 0,
      currentIndex: 0,
      marginLeft: -18,
      marginTop: -10,
      chipLeft: 10,
      chipTop: -15,
      sushiLeft: -50,
      sushiTop: 40,
      cloudLeft: -60,
      cloudTop: -40,

    },
    {
      id: 2,
      top: containerHeight * 0.65,
      left: containerWidth * 0.03,
      angle: 0,
      currentIndex: 1,
      marginLeft: -18,
      marginTop: -10,
      chipLeft: 48,
      chipTop: 20,
      sushiLeft: 48,
      sushiTop: 45,
      cloudLeft: 40,
      cloudTop: 10,
    },
    {
      id: 3,
      top: containerHeight * 0.45,
      left: containerWidth * 0.0,
      angle: 0,
      currentIndex: 2,
      marginLeft: -18,
      marginTop: -10,
      chipLeft: 50,
      chipTop: 20,
      sushiLeft: 48,
      sushiTop: 45,
         cloudLeft: 40,
      cloudTop: 10,
    },
    {
      id: 4,
      top: containerHeight * 0.25,
      left: containerWidth * 0.05,
      angle: 0,
      currentIndex: 3,
      marginLeft: -10,
      marginTop: -10,
      chipLeft: 50,
      chipTop: 15,
      sushiLeft: 48,
      sushiTop: -13,
         cloudLeft: 40,
      cloudTop: 10,
    },
    {
      id: 5,
      top: containerHeight * 0.1,
      left: containerWidth * 0.3,
      angle: 0,
      currentIndex: 4,
      marginLeft: -18,
      marginTop: -10,
      chipLeft: 50,
      chipTop: 12,
      sushiLeft: 48,
      sushiTop: 45,
      cloudLeft: 40,
      cloudTop: -45,
    },
    {
      id: 6,
      top: containerHeight * 0.1,
      left: containerWidth * 0.65,
      angle: 0,
      currentIndex: 5,
      marginLeft: -10,
      marginTop: -10,
      chipLeft: -30,
      chipTop: 12,
      sushiLeft: -48,
      sushiTop: 45,
      cloudLeft: -45,
      cloudTop: -45,
    },
    {
      id: 7,
      top: containerHeight * 0.25,
      left: containerWidth * 0.86,
      angle: 0,
      currentIndex: 6,
      marginLeft: -20,
      marginTop: -10,
      chipLeft: -28,
      chipTop: 15,
      sushiLeft: -48,
      sushiTop: -21,
      cloudLeft: -55,
      cloudTop: 15,
    },
    {
      id: 8,
      top: containerHeight * 0.45,
      left: containerWidth * 0.9,
      angle: 0,
      currentIndex: 7,
      marginLeft: -15,
      marginTop: -10,
      chipLeft: -35,
      chipTop: 50,
      sushiLeft: -48,
      sushiTop: 30,
         cloudLeft: -55,
      cloudTop: 15,
    },
    {
      id: 9,
      top: containerHeight * 0.65,
      left: containerWidth * 0.9,
      angle: 0,
      currentIndex: 8,
      marginLeft: -10,
      marginTop: -10,
      chipLeft: -28,
      chipTop: 20,
      sushiLeft: -48,
      sushiTop: 45,
      cloudLeft: -55,
      cloudTop: 15,
    },
  ],
  8: [
    {
      id: 1,
      top: containerHeight * 0.85,
      left: containerWidth * 0.5,
      angle: 0,
      currentIndex: 0,
      marginLeft: -18,
      marginTop: -10,
      chipLeft: 10,
      chipTop: -15,
      sushiLeft: -50,
      sushiTop: 45,
       cloudLeft: -60,
      cloudTop: -40,
    },
    {
      id: 2,
      top: containerHeight * 0.65,
      left: containerWidth * 0.03,
      angle: 0,
      currentIndex: 1,
      marginLeft: -18,
      marginTop: -10,
      chipLeft: 50,
      chipTop: 20,
      sushiLeft: 48,
      sushiTop: 45,
        cloudLeft: 40,
      cloudTop: 10,
    },
    {
      id: 3,
      top: containerHeight * 0.45,
      left: containerWidth * 0.0,
      angle: 0,
      currentIndex: 2,
      marginLeft: -18,
      marginTop: -10,
      chipLeft: 50,
      chipTop: 20,
      sushiLeft: 48,
      sushiTop: 45,
       cloudLeft: 40,
      cloudTop: 10,
    },
    {
      id: 4,
      top: containerHeight * 0.25,
      left: containerWidth * 0.05,
      angle: 0,
      currentIndex: 3,
      marginLeft: -9,
      marginTop: -10,
      chipLeft: 48,
      chipTop: 15,
      sushiLeft: 48,
      sushiTop: -21,
        cloudLeft: 40,
      cloudTop: 10,
    },
    {
      id: 5,
      top: containerHeight * 0.1,
      left: containerWidth * 0.3,
      angle: 0,
      currentIndex: 4,
      marginLeft: -18,
      marginTop: -25,
      chipLeft: 10,
      chipTop: 90,
      sushiLeft: -48,
      sushiTop: 45,
       cloudLeft: -60,
      cloudTop: 0,
    },
    {
      id: 6,
      top: containerHeight * 0.1,
      left: containerWidth * 0.65,
      angle: 0,
      currentIndex: 5,
      marginLeft: -20,
      marginTop: -10,
      chipLeft: -28,
      chipTop: 15,
      sushiLeft: -48,
     sushiTop: -21,
      cloudLeft: -60,
      cloudTop: 30,
    },
    {
      id: 7,
      top: containerHeight * 0.25,
      left: containerWidth * 0.86,
      angle: 0,
      currentIndex: 6,
      marginLeft: -18,
      marginTop: -10,
      chipLeft: -27,
      chipTop: 20,
      sushiLeft: -48,
      sushiTop: 45,
       cloudLeft: -60,
      cloudTop: 30,
    },
    {
      id: 8,
      top: containerHeight * 0.45,
      left: containerWidth * 0.9,
      angle: 0,
      currentIndex: 7,
      marginLeft: -18,
      marginTop: -10,
      chipLeft: -27,
      chipTop: 20,
      sushiLeft: -48,
      sushiTop: 45,
       cloudLeft: -60,
      cloudTop: 30,
    },
  ],
  7: [
    {
      id: 1,
      top: containerHeight * 0.85,
      left: containerWidth * 0.5,
      angle: 0,
      currentIndex: 0,
      marginLeft: -18,
      marginTop: -10,
      chipLeft: 10,
      chipTop: -15,
      sushiLeft: -50,
      sushiTop: 45,
       cloudLeft: -60,
      cloudTop: -40,
    },
    {
      id: 2,
      top: containerHeight * 0.65,
      left: containerWidth * 0.03,
      angle: 0,
      currentIndex: 1,
      marginLeft: -18,
      marginTop: -10,
      chipLeft: 50,
      chipTop: 20,
      sushiLeft: 48,
      sushiTop: 45,
       cloudLeft: 40,
      cloudTop: 10,
    },
    {
      id: 3,
      top: containerHeight * 0.45,
      left: containerWidth * 0.0,
      angle: 0,
      currentIndex: 2,
      marginLeft: -10,
      marginTop: -10,
      chipLeft: 45,
      chipTop: 5,
      sushiLeft: 48,
     sushiTop: -21,
    cloudLeft: 40,
      cloudTop: 10,
    },
    {
      id: 4,
      top: containerHeight * 0.25,
      left: containerWidth * 0.05,
      angle: 0,
      currentIndex: 3,
      marginLeft: -18,
      marginTop: -15,
      chipLeft: 50,
      chipTop: 15,
      sushiLeft: 48,
      sushiTop: 45,
     cloudLeft: 40,
      cloudTop: -45,
    },
    {
      id: 5,
      top: containerHeight * 0.1,
      left: containerWidth * 0.3,
      angle: 0,
      currentIndex: 4,
      marginLeft: -18,
      marginTop: -15,
      chipLeft: -30,
      chipTop: 15,
      sushiLeft: -48,
      sushiTop: 45,
      cloudLeft: -45,
      cloudTop: -40,
    },
    {
      id: 6,
      top: containerHeight * 0.1,
      left: containerWidth * 0.65,
      angle: 0,
      currentIndex: 5,
      marginLeft: -21,
      marginTop: -10,
      chipLeft: -28,
      chipTop: 6,
      sushiLeft: -48,
      sushiTop: -21,
      cloudLeft: -60,
      cloudTop: 10,
    },
    {
      id: 7,
      top: containerHeight * 0.25,
      left: containerWidth * 0.86,
      angle: 0,
      currentIndex: 6,
      marginLeft: -10,
      marginTop: -10,
      chipLeft: -28,
      chipTop: 20,
      sushiLeft: -48,
      sushiTop: 45,
      cloudLeft: -60,
      cloudTop: 10,
    },
  ],
  6: [
    {
      id: 1,
      top: containerHeight * 0.85,
      left: containerWidth * 0.5,
      angle: 0,
      currentIndex: 0,
      marginLeft: -18,
      marginTop: -10,
      chipLeft: 10,
      chipTop: -15,
      cloudLeft: -60,
      cloudTop: -40,
    },
    {
      id: 2,
      top: containerHeight * 0.65,
      left: containerWidth * 0.03,
      angle: 0,
      currentIndex: 1,
      marginLeft: -20,
      marginTop: -10,
      chipLeft: 45,
      chipTop: 20,
      sushiLeft: 48,
      sushiTop: 45,
        cloudLeft: 40,
      cloudTop: 10,
    },
    {
      id: 3,
      top: containerHeight * 0.45,
      left: containerWidth * 0.0,
      angle: 0,
      currentIndex: 2,
      marginLeft: -10,
      marginTop: -10,
      chipLeft: 48,
      chipTop: 10,
      sushiLeft: 48,
      sushiTop: -21,
        cloudLeft: 40,
      cloudTop: 10,
    },
    {
      id: 4,
      top: containerHeight * 0.25,
      left: containerWidth * 0.05,
      angle: 0,
      currentIndex: 3,
      marginLeft: -10,
      marginTop: -20,
      chipLeft: 10,
      chipTop: 90,
      sushiLeft: -48,
      sushiTop: 45,
        cloudLeft: -65,
      cloudTop: 0,
    },
    {
      id: 5,
      top: containerHeight * 0.25,
      left: containerWidth * 0.05,
      angle: 0,
      currentIndex: 3,
      marginLeft: -20,
      marginTop: -10,
      chipLeft: -25,
      chipTop: 10,
      sushiLeft: -48,
      sushiTop: -21,
        cloudLeft: -60,
      cloudTop: 10,
    },
    {
      id: 6,
      top: containerHeight * 0.1,
      left: containerWidth * 0.3,
      angle: 0,
      currentIndex: 4,
      marginLeft: -15,
      marginTop: -10,
      chipLeft: -28,
      chipTop: 25,
      sushiLeft: -48,
      sushiTop: 45,
        cloudLeft: -60,
      cloudTop: -40,
    },
  ],
  5: [
    {
      id: 1,
      top: containerHeight * 0.85,
      left: containerWidth * 0.5,
      angle: 0,
      currentIndex: 0,
      marginLeft: -18,
      marginTop: -10,
      chipLeft: 10,
      chipTop: -15,
      sushiLeft: -50,
      sushiTop: 45,
    cloudLeft: -60,
      cloudTop: -40,
    },
    {
      id: 2,
      top: containerHeight * 0.65,
      left: containerWidth * 0.03,
      angle: 0,
      currentIndex: 1,
      marginLeft: -20,
      marginTop: -10,
      chipLeft: 50,
      chipTop: 20,
      sushiLeft: 48,
      sushiTop: 45,
    cloudLeft: 40,
      cloudTop: 10,
    },
    {
      id: 3,
      top: containerHeight * 0.45,
      left: containerWidth * 0.0,
      angle: 0,
      currentIndex: 2,
      marginLeft: 0,
      marginTop: -10,
      chipLeft: 50,
      chipTop: 10,
      sushiLeft: 48,
      sushiTop: -21,
     cloudLeft: 40,
      cloudTop: 10,
    },
    {
      id: 4,
      top: containerHeight * 0.25,
      left: containerWidth * 0.05,
      angle: 0,
      currentIndex: 3,
      marginLeft: -21,
      marginTop: -10,
      chipLeft: -28,
      chipTop: 10,
      sushiLeft: -48,
      sushiTop: -21,
     cloudLeft: -60,
      cloudTop: 10,
    },
    {
      id: 5,
      top: containerHeight * 0.1,
      left: containerWidth * 0.3,
      angle: 0,
      currentIndex: 4,
      marginLeft: -15,
      marginTop: -10,
      chipLeft: -28,
      chipTop: 20,
      sushiLeft: -48,
      sushiTop: 45,
     cloudLeft: -60,
      cloudTop: 10,
    },
  ],
  4: [
    {
      id: 1,
      top: containerHeight * 0.85,
      left: containerWidth * 0.5,
      angle: 0,
      currentIndex: 0,
      marginLeft: -18,
      marginTop: -10,
      chipLeft: 10,
      chipTop: -15,
      sushiLeft: -50,
      sushiTop: 45,
       cloudLeft: -60,
      cloudTop: -40,
    },
    {
      id: 2,
      top: containerHeight * 0.65,
      left: containerWidth * 0.03,
      angle: 0,
      currentIndex: 1,
      marginLeft: -18,
      marginTop: -10,
      chipLeft: 50,
      chipTop: 20,
      sushiLeft: 48,
      sushiTop: 45,
        cloudLeft: 40,
      cloudTop: 10,
    },
    {
      id: 3,
      top: containerHeight * 0.45,
      left: containerWidth * 0.0,
      angle: 0,
      currentIndex: 2,
      marginLeft: -10,
      marginTop: -20,
      chipLeft: 10,
      chipTop: 90,
      sushiLeft: -48,
      sushiTop: 45,
       cloudLeft: -60,
      cloudTop: 0,
    },
    {
      id: 4,
      top: containerHeight * 0.25,
      left: containerWidth * 0.05,
      angle: 0,
      currentIndex: 3,
      marginLeft: -18,
      marginTop: -10,
      chipLeft: -28,
      chipTop: 20,
      sushiLeft: -48,
      sushiTop: 45,
       cloudLeft: -60,
      cloudTop: 0,
    },
  ],
  3: [
    {
      id: 1,
      top: containerHeight * 0.85,
      left: containerWidth * 0.5,
      angle: 0,
      currentIndex: 0,
      marginLeft: -18,
      marginTop: -10,
      chipLeft: 10,
      chipTop: -15,
      sushiLeft: -50,
      sushiTop: -21,
       cloudLeft: -60,
      cloudTop: -40,
    },
    {
      id: 2,
      top: containerHeight * 0.65,
      left: containerWidth * 0.03,
      angle: 0,
      currentIndex: 1,
      marginLeft: -5,
      marginTop: -10,
      chipLeft: 50,
      chipTop: 10,
      sushiLeft: 48,
   sushiTop: -21,
     cloudLeft: 40,
      cloudTop: 10,
    },
    {
      id: 3,
      top: containerHeight * 0.45,
      left: containerWidth * 0.0,
      angle: 0,
      currentIndex: 2,
      marginLeft: -20,
      marginTop: -10,
      chipLeft: -28,
      chipTop: 10,
      sushiLeft: -48,
    sushiTop: -21,
       cloudLeft: -60,
      cloudTop: 10,
    },
  ],
  2: [
    {
      id: 1,
      top: containerHeight * 0.85,
      left: containerWidth * 0.5,
      angle: 0,
      currentIndex: 0,
      marginLeft: -18,
      marginTop: -10,
      chipLeft: 10,
      chipTop: -15,
      sushiLeft: -50,
      sushiTop: 45,
       cloudLeft: -60,
      cloudTop: -40,
    },
    {
      id: 2,
      top: containerHeight * 0.65,
      left: containerWidth * 0.03,
      angle: 0,
      currentIndex: 1,
      marginLeft: -18,
      marginTop: -20,
      chipLeft: 10,
      chipTop: 90,
      sushiLeft: -48,
      sushiTop: 45,
      cloudLeft: -60,
      cloudTop: 0,
    },
  ],
};
//seat angles mapping
//which seat should be placed at which position angles will defiend x,y cordinates
export const seatMapWithAnlge = {
  9: { 1: 315, 2: 355, 3: 42, 4: 90, 5: 116, 6: 154, 7: 180, 8: 228, 9: 275 },
  8: { 1: 315, 2: 355, 3: 42, 4: 90, 5: 134, 6: 180, 7: 228, 8: 275 },
  7: { 1: 315, 2: 355, 3: 84, 4: 116, 5: 154, 6: 186, 7: 275 },
  6: { 1: 315, 2: 355, 3: 90, 4: 134, 5: 180, 6: 275 },
  5: { 1: 315, 2: 6, 3: 90, 4: 180, 5: 267 },
  4: { 1: 315, 2: 42, 3: 134, 4: 228 },
  3: { 1: 315, 2: 90, 3: 180 },
  2: { 1: 315, 2: 134 },
};
export const NLHChatseatGroups = {
  9: {
    bottom: [0],
    top: [4, 5],
    left: [1, 2, 3],
    right: [6, 7, 8],
  },
  8: {
    bottom: [0],
    top: [4],
    left: [1, 2, 3],
    right: [5, 6, 7],
  },
  7: { bottom: [0], top: [3, 4], left: [1, 2], right: [5, 6] },
  6: {
    bottom: [0],
    top: [3],
    left: [1, 2],
    right: [4, 5],
  },
  5: { bottom: [0], top: [], left: [1, 2], right: [3, 4] },
  4: {
    bottom: [0],
    top: [2],
    left: [1],
    right: [3],
  },
  3: {
    bottom: [0],
    top: [],
    left: [1],
    right: [2],
  },
  2: {
    bottom: [0],
    top: [1],
    left: [],
    right: [],
  },
};
